// extracted by mini-css-extract-plugin
export default {"imageWrapper":"yI-z","hovered":"zI-z","hoverImage":"AI-z","mainImage":"BI-z","imageNoBackground":"CI-z","fullSizeImage":"DI-z"};